import React from "react";
import { connect } from "react-redux";
import { Route, Switch } from "react-router-dom";
import LoadingModal from "src/modes/Electric/LoadingModal";
import LockedPricingDefaultRoute from "src/modes/Electric/Routes/LockedPricingDefaultRoute";
import UnlockedPricingDefaultRoute from "src/modes/Electric/Routes/UnlockedPricingDefaultRoute";
import OSModal from "src/components/OSModal";
import ProductAnalytics from "src/components/ProductAnalytics";
import RouteWatcher from "src/components/RouteWatcher";
import { ApplicationStore } from "src/store";
import { isLockedPricingSetup } from "src/store/selectors/account";
import { isVehicleLoading } from "src/store/selectors/vehicles";
// import ReactLazyPreload from "src/utils/ReactLazyPreload";
import CustomizePayment from "src/components/CustomizePayment";
import CreateGarage from "src/components/UserAccount/CreateGarage";
import MyGarage from "src/components/MyGarage";
import AccessGarage from "src/components/UserAccount/AccessGarage";
import UnlockGarage from "src/components/UserAccount/UnlockGarage";
import ContinueDeal from "src/components/ContinueDeal";
import ContinueDealerOffer from "src/components/ContinueDealerOffer";

// const CustomizePayment = ReactLazyPreload(() => import("src/components/CustomizePayment"));
// const CreateGarage = ReactLazyPreload(() => import("src/components/UserAccount/CreateGarage"));
// const MyGarage = ReactLazyPreload(() => import("src/components/MyGarage"));
// const AccessGarage = ReactLazyPreload(() => import("src/components/UserAccount/AccessGarage"));
// const UnlockGarage = ReactLazyPreload(() => import("src/components/UserAccount/UnlockGarage"));
// const ContinueDeal = ReactLazyPreload(() => import("src/components/ContinueDeal"));
// const ContinueDealerOffer = ReactLazyPreload(() => import("src/components/ContinueDealerOffer"));

// const preLoadStage1 = [CustomizePayment, CreateGarage, AccessGarage, UnlockGarage];
//
// const preLoadStage2 = [MyGarage, ContinueDeal, ContinueDealerOffer];

function ElectricModal({
    // isAccountLoaded,
    isAppOpen,
    // isGarageCreated,
    isLockedPricing,
    isToggledVehicleLoading,
}: ReturnType<typeof mapStateToProps> & { isAppOpen: boolean }) {
    // useEffect(() => {
    //     if (isAccountLoaded && !isGarageCreated) {
    //         isLockedPricing ? CreateGarage.preload() : CustomizePayment.preload();
    //         return;
    //     } else if (isGarageCreated) {
    //         MyGarage.preload();
    //     }
    // }, [isAccountLoaded, isLockedPricing, isGarageCreated]);
    //
    // useEffect(() => {
    //     if (isAppOpen) {
    //         setTimeout(() => preLoadStage1.map((component) => component.preload()), 3000);
    //         setTimeout(() => preLoadStage2.map((component) => component.preload()), 8000);
    //     }
    // }, [isAppOpen]);

    if (!isAppOpen) {
        return null;
    }

    return (
        <OSModal>
            <ProductAnalytics>
                <RouteWatcher>
                    <Switch>
                        <Route
                            exact
                            path="/"
                            component={isLockedPricing ? LockedPricingDefaultRoute : UnlockedPricingDefaultRoute}
                        />
                        <Route
                            path="/payment-builder"
                            component={isToggledVehicleLoading ? LoadingModal : CustomizePayment}
                        />
                        <Route path="/my-garage" component={MyGarage} />
                        <Route path="/access-my-garage" component={AccessGarage} />
                        <Route path="/create/:locked?" component={CreateGarage} />
                        <Route path="/unlock-garage" component={UnlockGarage} />
                        <Route path="/continue-deal" component={ContinueDeal} />
                        <Route path="/dealer-offer" component={ContinueDealerOffer} />
                    </Switch>
                </RouteWatcher>
            </ProductAnalytics>
        </OSModal>
    );
}

function mapStateToProps(state: ApplicationStore) {
    return {
        // isGarageCreated: state.onlineShopper.garageCreated,
        // isAccountLoaded: !state.account.loading,
        isLockedPricing: isLockedPricingSetup(state),
        isToggledVehicleLoading:
            state.onlineShopper.toggledVin && isVehicleLoading(state, state.onlineShopper.toggledVin),
    };
}
export default connect(mapStateToProps)(ElectricModal);
